import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { RutasTiendasConfiguracion } from "../Rutas/RutasTiendasConfiguracion/RutasTiendasConfiguracion";

export const ACTVerRutasEnTiendaDashboard: EntityClientAction = {
    name: 'ACTVerRutasEnTiendaDashboard',
    label: 'Ver Rutas en Tienda',
    title: <Text fw={700}>Ver Rutas en Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['dash_brwTiendasVisitasPersonal'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const tiendasConfig = new RutasTiendasConfiguracion(entity.API.client);
        tiendasConfig.def.columns.c_tienda_id.value = selectedKeys?.[0].c_tienda_id as string;

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: tiendasConfig,
                initialFormMode: 'view',
                getDataOnInit: true,
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(false); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(false); }
        });

        return false;
    }
}